export default __webpack_public_path__ + "static/media/Home-Office.3154192c.webp";